import { render, staticRenderFns } from "./LecturesLearningTrackEntity.vue?vue&type=template&id=20132051&scoped=true"
import script from "./LecturesLearningTrackEntity.vue?vue&type=script&lang=js"
export * from "./LecturesLearningTrackEntity.vue?vue&type=script&lang=js"
import style0 from "./LecturesLearningTrackEntity.vue?vue&type=style&index=0&id=20132051&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20132051",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20132051')) {
      api.createRecord('20132051', component.options)
    } else {
      api.reload('20132051', component.options)
    }
    module.hot.accept("./LecturesLearningTrackEntity.vue?vue&type=template&id=20132051&scoped=true", function () {
      api.rerender('20132051', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LecturesLearningTrackEntity.vue"
export default component.exports